import type { RouteRecordRaw } from 'vue-router'
import Login from '../views/auth/login-view.vue'
import { useAdminStore } from '@/stores/admin'

const routes: readonly RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    redirect: (to) => {
      // TODO: use the token's expiration time
      if (useAdminStore().token === null) {
        return { path: '/login' }
      } else {
        return { path: '/producers' }
      }
    },
  },
]

export default routes
